import React from 'react'
import { Button, Popup } from 'semantic-ui-react'
import firebase from 'firebase/app'

export default class FindDriverButton extends React.PureComponent {
  state = { visible: false }

  onPopupAction = () => {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  onFindClick = async () => {
    const { order, setLoading, readOnly, queueOrders, isExpress, refindDriver } = this.props

    if (readOnly) return

    try {
      this.setState({ visible: false })
      setLoading('finding', true)

      const { actionName, ...params } = isExpress ? {
        orderUid: order.id,
        refind: refindDriver,
        actionName: 'expressAction',
        actionType: 'assign-express-driver',
        queueOrderUids: queueOrders && queueOrders.map(o => o.id).splice(1),
      } : {
        orderUid: order.key,
        actionName: 'orderAction',
        actionType: 'find-driver',
        refind: order.status === 'drivers_not_available',
        queueOrderUids: queueOrders && queueOrders.map(o => o.key),
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable(actionName)

      await functions(params)

      setLoading('finding', false)
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(error.message || error)
      setLoading('finding', false)
    }
  }

  onManualClick = () => {
    const { showManualAssign, readOnly } = this.props

    if (readOnly) return

    this.setState({ visible: false }, showManualAssign)
  }

  render() {
    const { visible } = this.state
    const { order, finding, readOnly, refindDriver } = this.props

    let label = 'Find Driver'
    let triggerLabel = 'Choose'
    let triggerIcon = 'angle down'
    let triggerColor = {}

    if (refindDriver || order.status === 'drivers_not_available') {
      label = 'Refind Driver'
      triggerLabel = 'Refind'
      triggerIcon = 'repeat'
      triggerColor = { color: 'black' }
    }

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        open={visible}
        position="bottom center"
        onOpen={this.onPopupAction}
        onClose={this.onPopupAction}
        trigger={
          <Button
            size="mini"
            loading={finding}
            icon={triggerIcon}
            labelPosition="right"
            content={triggerLabel}
            disabled={finding || readOnly}
            style={{ width: 120, margin: 0, marginTop: 5 }}
            {...triggerColor}
          />
        }
      >
        <React.Fragment>
          <Button size="tiny" fluid onClick={this.onFindClick} disabled={readOnly}>
            {label}
          </Button>
        </React.Fragment>

        <div style={{ marginTop: 3 }}>
          <Button size="tiny" fluid onClick={this.onManualClick} disabled={readOnly}>
            Manual Assign
          </Button>
        </div>
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/FindDriver.js